import type { Reaction, ReactionCounts } from './post-service';

const REACTION_NAMES: Reaction[] = [
  'love',
  'like',
  'dislike',
  'laugh',
  'wow',
  'vomit',
  'fire',
  'trash',
];

export function reactionCountsEqual(
  first: ReactionCounts,
  second: ReactionCounts,
) {
  return REACTION_NAMES.every(
    (reaction) => first[reaction] === second[reaction],
  );
}

export function createReactionMutationId() {
  const timePart = Date.now().toString(36);
  const randomPart = Math.random().toString(36).slice(2, 12);

  return `${timePart}-${randomPart}`;
}

export function shouldClearOptimisticReaction({
  currentCounts,
  currentMutationAck,
  expectedCounts,
  persistedReaction,
  queuedReaction,
  startingCounts,
  targetMutationId,
  targetReaction,
}: {
  currentCounts: ReactionCounts;
  currentMutationAck?: string | null;
  expectedCounts: ReactionCounts;
  persistedReaction: Reaction | null;
  queuedReaction?: Reaction | null;
  startingCounts: ReactionCounts;
  targetMutationId?: string | null;
  targetReaction: Reaction | null;
}) {
  const reactionSynced =
    queuedReaction === targetReaction || persistedReaction === targetReaction;

  if (!reactionSynced) {
    return false;
  }

  if (
    targetMutationId &&
    currentMutationAck != null &&
    currentMutationAck === targetMutationId
  ) {
    return true;
  }

  return REACTION_NAMES.every((reaction) => {
    const startingCount = startingCounts[reaction];
    const expectedCount = expectedCounts[reaction];

    if (expectedCount !== startingCount) {
      return currentCounts[reaction] !== startingCount;
    }

    return true;
  });
}
